<template>
  <div style="padding-top: 5px; width: 830px; background-color: #f5f7f7;">
    <div class="app-main-inner carry-over">
      <div class="app-main-inner-row" style="padding: 0; margin-left: 10px; justify-content: flex-start;">
        <span style="font-size: 16px;">{{ IssueOfTheYear }}</span>
        <span style="font-size: 13px; margin-left: 15px;">{{ carryoverAccountingDocumentNo }}</span>
      </div>
      <el-form :inline="true" label-position="left">
        <div class="app-main-inner-row" style="padding: 0; margin-left: 10px; justify-content: flex-start;">
          <el-form-item :label="$t('CargoMsg.Cargo_ProofDateP')" class="el-form-item-documentDate">
            <el-date-picker
              v-model="documentDate"
              type="date"
              :clearable="false"
              value-format="yyyy-MM-dd"
              :editable="false"
              no="1"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_VoucherLetter')" class="el-form-item-prefix" style="word-break: break-all; white-space: normal;">
            <el-select v-model="prefix" no="2">
              <el-option v-for="(item,index) in prefixList" :key="index" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_VoucherNo')" class="el-form-item-documentNo">
            <el-input-number
              v-model="documentNo"
              :min="0"
              :precision="0"
              :controls="false"
              no="3"
              @blur="e => { if (e.target.value <= 0) documentNo = undefined }"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_VoucherAbstract')" class="el-form-item-summary">
            <el-input v-model="summary" no="4" />
          </el-form-item>
        </div>
        <div class="app-main-inner-row" style="padding: 0; margin-left: 10px; margin-top: 5px; justify-content: flex-start;">
          <el-form-item :label="$t('CargoMsg.Cargo_CurrentYearProfitAccountP')" class="el-form-item-carryOverAccountTitle">
            <el-select v-model="carryOverAccountTitle" :filterable="true" no="5">
              <el-option
                v-for="(item,index) in accountTitleCollection"
                :key="index"
                :label="accountTitleLabelFun(item)"
                :value="item.accountTitle"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_PYPALAAP')" class="el-form-item-carryOverBeforeAccountTitle">
            <el-select v-model="carryOverBeforeAccountTitle" :filterable="true" no="6">
              <el-option
                v-for="(item,index) in accountTitleCollection"
                :key="index"
                :label="accountTitleLabelFun(item)"
                :value="item.accountTitle"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AccountTitleOfProfitNotAllocatedP')" class="el-form-item-carryOverUnProfitAccountTitle">
            <el-select v-model="carryOverUnProfitAccountTitle" :filterable="true" no="7">
              <el-option
                v-for="(item,index) in accountTitleCollection"
                :key="index"
                :label="accountTitleLabelFun(item)"
                :value="item.accountTitle"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div class="app-main-inner-row" style="margin-left: 10px; margin-bottom: 10px; margin-top: 250px;flex-direction: row-reverse;">
        <el-button type="primary" :disabled="isProcessing" no="8" @click="generateCarryOverBtnClickHandler">{{ $t('CargoMsg.Cargo_CreateVoucher') }}</el-button>
      </div>
    </div>
    <div style="height: 100%; background-color: #e2e8f3;" />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { generateCarryOverAccountingDocument } from '@/api/financeManage/accountingDocument'
import StrUtils from '@/utils/StrUtils'
import * as accountingDocumentTypeApi from '@/api/financeManage/accountingDocumentType'

export default {
  name: 'CarryOver',
  props: {
    accountSet: { type: Object } // 账套
  },
  data() {
    return {
      documentDate: null, // 凭证日期
      prefix: '收', // 凭证字
      documentNo: undefined, // 凭证号
      summary: this.$t('FinanceManage.RetainedEarnings'), // 摘要
      carryOverAccountTitle: '', // 本年利润科目
      carryOverUnProfitAccountTitle: '', // 未分配利润科目
      carryOverBeforeAccountTitle: '', // 以前年度损益调整科目
      processing: false,
      prefixList: [] // 凭证字下拉框集合
    }
  },
  computed: {
    IssueOfTheYear() {
      return this.accountSet ? this.$t('CargoMsg.Cargo_IssueOfTheYear').format(this.accountSet.currentFiscalPeriod.year, this.accountSet.currentFiscalPeriod.month) : ''
    },
    accountTitleCollection() {
      return this.accountSet ? this.accountSet.accountTitle : []
    },
    carryoverAccountingDocumentNo() {
      let documentNo = ''
      if (this.accountSet && this.accountSet.result) {
        const carryoverAccountingDocument = this.accountSet.result.carryoverAccountingDocument
        if (carryoverAccountingDocument !== '') {
          documentNo = this.$t('CargoMsg.Cargo_CCOPLV') + carryoverAccountingDocument.prefix + '-' + carryoverAccountingDocument.documentNo
        }
      }
      return documentNo
    },
    isProcessing() {
      return this.processing
    }
  },
  created() {
    this.updateCarryoverAccountingDocument()
  },
  methods: {
    accountTitleLabelFun(accountTitle) {
      return accountTitle ? accountTitle.accountTitle + '_' + accountTitle.accountTitleName : ''
    },
    // 生成凭证
    generateCarryOverBtnClickHandler() {
      if (!this.validatePreCarryOver()) return
      const requestBody = {
        'accountSetKey': this.accountSet.uuid,
        'currentFiscalPeriodKey': this.accountSet.currentFiscalPeriod.uuid,
        'prefix': this.prefix,
        'documentNo': this.documentNo,
        'summary': this.summary,
        'documentDate': this.documentDate,
        'carryOverAccountTitle': this.carryOverAccountTitle,
        'carryOverUnProfitAccountTitle': this.carryOverUnProfitAccountTitle,
        'carryOverBeforeAccountTitle': this.carryOverBeforeAccountTitle,
        'branchId': this.$store.getters.currentOfficeId }
      if (this.isProcessing) return
      this.processing = true
      this.loading = getLoading()
      generateCarryOverAccountingDocument(requestBody).then(res => {
        this.accountSet.result.carryoverAccountingDocument = res.data
        if (res.data !== '') {
          this.$message.success(this.$t('CargoMsg.Cargo_PLCOS'))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_NNTCVFCOPL'))
        }
      }).finally(() => {
        this.processing = false
        this.loading.close()
      })
    },
    validatePreCarryOver() {
      if (!this.documentDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PLVDCTBE'))
        return false
      }
      if (this.documentDate < this.accountSet.currentFiscalPeriod.beginDate || this.documentDate > this.accountSet.currentFiscalPeriod.endDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PLVDNITP'))
        return false
      }
      if (StrUtils.isEmpty(this.prefix)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PLVFCTBE'))
        return false
      }
      if (StrUtils.isEmpty(this.summary)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_AOPLVCTBE'))
        return false
      }
      if (StrUtils.isEmpty(this.carryOverAccountTitle)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CYSPATIPLVCTBE'))
        return false
      }
      if (StrUtils.isEmpty(this.carryOverUnProfitAccountTitle)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PLVNAPATCTBE'))
        return false
      }
      return true
    },
    async updateCarryoverAccountingDocument() {
      this.prefixList = [
        { value: '收', label: this.$t('FinanceManage.Receive') },
        { value: '付', label: this.$t('FinanceManage.Pay') },
        { value: '转', label: this.$t('FinanceManage.Transfer') },
        { value: '*', label: '*' }
      ]
      if (this.accountSet) {
        if (this.accountSet.currentFiscalPeriod) {
          if (this.accountSet.result && this.accountSet.result.carryoverAccountingDocument !== '') {
            const carryoverAccountingDocument = this.accountSet.result.carryoverAccountingDocument
            this.documentDate = carryoverAccountingDocument.documentDate
            this.prefix = carryoverAccountingDocument.prefix
            this.documentNo = carryoverAccountingDocument.documentNo
          } else {
            this.documentDate = this.accountSet.currentFiscalPeriod.endDate
            this.prefix = '收'
            this.documentNo = undefined
          }
        }
        // 加载凭证字
        if (this.accountSet.uuid) {
          await accountingDocumentTypeApi.query({ accountingSetKey: this.accountSet.uuid }).then(res => {
            if (res.data.list && res.data.list.length > 0) {
              for (const row of res.data.list) {
                if (row.prefix && this.prefixList.findIndex(p => p.value === row.prefix) < 0) {
                  this.prefixList.push({ value: row.prefix, label: row.prefix })
                }
              }
            }
          }).catch(() => {})
        }
      }
    }
  }
}
</script>
